export default {
    siteSetup: false,
    loading: false,
    scanRemainingSeconds: null,
    generating: false,
    generationSuccess: false,
    lockedConfig: false,
    errors: [],
    messages: [],
    configurationUpdatePending: false,

    mode: 'configuration', // configuration | device-config

    site: {},
    supportedProductIds: [],

    supportedProtocols: {},
    deviceThings: [], // Legacy: Array of available 'things' for selected device
    deviceTemplateThings: {}, // New: Object of available 'things' for each device template
    deviceTemplateDatapoints: {}, // New: Object of available 'datapoints' for each device config, keyed by configId
    previousDeviceTemplateThings: {}, // Keep as reference to see which metadata keys should be removed on specification change
    protocolDefaults: {},
    emsCapabilities: {},
    supportedExternalPlantControlTypes: {},
    slaveSpecifications: {},
    slaveOnlyDevices: [],

    manufacturers: [],
    productModels: [],
    productModelVersions: [],
    deviceSpecifications: [],

    extensionManufacturers: [],
    extensionModels: [],
    extensionThings: [],
    supportedExtensionFeatures: [],

    eebusBeaamSmartHomeIPQRCodeURL: null,
    eebusBeaamSubjectKeyIdentifier: null,

    plannedThings: [],
    plannedProducts: [],
    plannedExtensions: [],
    externalPlantControls: [],
    emsData: {},
    residualThings: [],

    savedConfig: {devices: [], things: [], cms: [], products: []}, // Current saved config, which will be loaded from API.
    generatedConfig: null,

    editingDevice: null,
    editingProduct: null,
    editingExtension: null,

    productDiscoveryPayload: null,
    extensionDiscoveryPayload: null,

    deviceThingsBackup: {},

    experimental: false, // to show hide experimental features
    hasSystemRole: false, // to show and hide links to edit products
    redirectUrl: null,
    latestConfigTimestamp: null,
    currentLinkConfigurations: {}
}
